export default function Hero() {
  const stats = [
    { value: '24H', label: '全天候实时追踪' },
    { value: '1000+', label: '累计独家爆料' },
    { value: '50万+', label: '活跃吃瓜群众' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20with%20warm%20crimson%20and%20deep%20charcoal%20tones%2C%20abstract%20composition%20of%20layered%20newspaper%20textures%20and%20digital%20media%20elements%2C%20moody%20atmospheric%20lighting%20with%20soft%20shadows%2C%20modern%20newsroom%20aesthetic%20with%20hints%20of%20breaking%20news%20urgency%2C%20textured%20dark%20background%20with%20warm%20ambient%20glow%2C%20cinematic%20composition%2C%20professional%20editorial%20style&width=1600&height=900&seq=hero-bg-91hl&orientation=landscape"
          alt="91黑料网 - 最新黑料吃瓜与爆料曝光平台背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 backdrop-blur-sm mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
              <span className="text-primary-200 text-sm font-medium whitespace-nowrap">实时吃瓜</span>
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              91黑料网
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mt-2 text-white/85">
                全网最新黑料吃瓜与爆料曝光平台
              </span>
            </h1>

            <p className="text-white/70 text-base md:text-lg font-medium mb-2">
              每日更新 · 深度追踪 · 独家爆料
            </p>

            <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              聚焦全网热门黑料事件，第一时间追踪内幕爆料与深度吃瓜。从娱乐圈到网红圈，从商业黑幕到社会热点，
              91黑料网为你提供最新、最全、最劲爆的吃瓜内容。每日实时更新，绝不漏掉任何一个值得关注的瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-white font-heading">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1 whitespace-nowrap">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-flashlight-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[440px] md:w-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20photography%2C%20dramatic%20warm%20lighting%20on%20a%20modern%20digital%20media%20concept%2C%20abstract%20composition%20with%20glowing%20screen%20elements%20and%20layered%20news%20imagery%2C%20rich%20crimson%20and%20gold%20accents%2C%20mysterious%20cinematic%20atmosphere%2C%20professional%20editorial%20photography%20with%20soft%20depth%20of%20field%2C%20storytelling%20visuals%20evoking%20investigative%20journalism&width=800&height=1000&seq=hero-main-91hl&orientation=portrait"
                alt="91黑料网 - 全网黑料吃瓜爆料平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
                <span className="text-white/80 text-xs font-medium">#每日吃瓜 #实时追踪</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}